import { createGraphqlHeader } from '../../utils/functions/headers';
import { graphQLEmptySplitApi } from '../emptySplitApi';
import {
  TFilterData,
  TGetFieldDataForFieldNosResponse,
  TMVPMapFilters,
  TMVPMapGetFarmDataFilters,
} from '../../types/mvpMap';
import {
  getFieldDataForFieldNosQueryString,
  getFilterDataForMapQueryString,
} from './queryHelpers';

export const MVPGraphQlService =
  graphQLEmptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getFilterDataForMap: builder.query<
        TFilterData,
        TMVPMapFilters
      >({
        query: (filters) => ({
          url: '',
          method: 'POST',
          data: {
            query: getFilterDataForMapQueryString(filters),
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () =>
            !filters?.commonFilters?.index ||
            !filters?.commonFilters?.season,
        }),
      }),
      getFieldDataForFieldNos: builder.query<
        TGetFieldDataForFieldNosResponse,
        TMVPMapGetFarmDataFilters
      >({
        query: (filters) => ({
          url: '',
          method: 'POST',
          data: {
            query:
              getFieldDataForFieldNosQueryString(filters),
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () =>
            !filters?.commonFilters?.index ||
            !filters?.commonFilters?.season,
        }),
      }),
    }),
  });

export const {
  useLazyGetFilterDataForMapQuery,
  useGetFilterDataForMapQuery,
  useLazyGetFieldDataForFieldNosQuery,
  useGetFieldDataForFieldNosQuery,
} = MVPGraphQlService;
